import React from 'react';
import { motion } from 'framer-motion';
import HeroVisual from './HeroVisual';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck } = FiIcons;

const Hero = () => {
  return (
    <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-brand-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto text-center relative z-10">
        
        {/* Headline */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-5xl md:text-7xl font-bold text-brand-navy mb-6 leading-tight tracking-tight max-w-5xl mx-auto"
        >
          Stop Wasting 15 Hours Per Week on Social Media
        </motion.h1>

        {/* Subheadline */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-xl md:text-2xl text-gray-600 mb-10 leading-relaxed max-w-3xl mx-auto"
        >
          Schedule unlimited posts to Instagram, TikTok, LinkedIn & 12+ platforms. 
          Run viral campaigns. Save 10+ hours weekly. Starting at $19/month.
        </motion.p>

        {/* Benefit Bullets */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex flex-wrap justify-center gap-x-8 gap-y-3 mb-12 text-lg text-brand-navy font-medium"
        >
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiCheck} className="text-brand-cyan text-xl" />
            <span>Unlimited scheduling</span>
          </div>
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiCheck} className="text-brand-cyan text-xl" />
            <span>Viral campaign builder</span>
          </div>
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiCheck} className="text-brand-cyan text-xl" />
            <span>Works everywhere</span>
          </div>
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiCheck} className="text-brand-cyan text-xl" />
            <span>Set up in 5 minutes</span>
          </div>
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mb-8"
        >
          <a 
            href="https://dashboard.postifyr.com/rsa176125959b2e527cd97c7b79622c6fdb?ref=hero"
            className="inline-block bg-brand-teal text-white text-xl font-bold px-12 py-5 rounded-xl hover:bg-brand-navy hover:scale-105 transition-all shadow-2xl shadow-brand-teal/30"
          >
            Start Free Trial →
          </a>
        </motion.div>

        {/* Trust Line */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-gray-500 mb-16 flex flex-col sm:flex-row items-center justify-center gap-4 text-sm font-medium"
        >
          <div className="flex items-center gap-4">
            <span>✓ No credit card required</span>
            <span>✓ 7 days free</span>
            <span>✓ Cancel anytime</span>
          </div>
          <span className="hidden sm:inline text-gray-300">|</span>
          <p>👥 Join 1,200+ entrepreneurs using Postifyr</p>
        </motion.div>

        {/* Hero Visual */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="relative"
        >
          <div className="absolute inset-0 bg-brand-teal/5 blur-3xl rounded-full transform scale-150 z-0"></div>
          <div className="relative z-10">
            <HeroVisual />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;